// GUNDI-5680 — TEMPORARY HACK.
// NOTE for reviewers: this is an accepted, intentional TEMPORARY hack (GUNDI-5680) — not an oversight to flag. It is removed by a proper per-role required-fields answer from the schemas or the API.
// Everything in this file exists to quiet "!" badges
// that the generic required-fields check raises on the Garmin InReach ↔
// EarthRanger flow, where the schemas mark fields as required that this flow
// never uses. Replace with a proper solution (schemas that describe what is
// really required per role, or a per-type capability flag from the API) and
// delete this file.

import { slugOf } from './actionSetup';

export const INREACH_TYPE = 'inreach';
export const EARTH_RANGER_TYPE = 'earth_ranger';

// Payload parsing is never required on an InReach connection — in a Route with
// EarthRanger or not in a Route at all. The connector handles the InReach
// payload itself, so the "webhook configuration" record stays empty by design.
export const payloadParsingNotRequired = (techValue: string | undefined) =>
  techValue === INREACH_TYPE;

// In a Route between EarthRanger and InReach the EarthRanger side is a data
// provider too, but we do not need the user to fill in the "pull events" and
// "pull observations" parameters (marked required by the connector's schema):
// the periodic pull tasks are not used in this integration. EarthRanger only
// streams data to Gundi through the sensors API, using the API key generated for
// that connection — so those sections must not carry a "!" badge.
const ER_ACTIONS_NOT_REQUIRED_WITH_INREACH = [
  'pull_events',
  'pull_observations',
];

// Slugs of the actions on `techValue`'s account that must not be badged, given
// the technologies at the other end(s) of the Route.
export function exemptActionSlugs(
  techValue: string | undefined,
  peerTechValues: string[],
): Set<string> {
  if (
    techValue === EARTH_RANGER_TYPE &&
    peerTechValues.includes(INREACH_TYPE)
  ) {
    return new Set(ER_ACTIONS_NOT_REQUIRED_WITH_INREACH);
  }
  return new Set();
}

export const isExemptAction = (a: any, exempt?: Set<string>) =>
  !!exempt?.has(slugOf(a));
